// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/vfr-routes-checkpoints.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/vfr-routes-checkpoints/published-vfr-checkpoints.js';
import g1 from '../lessons/navigation/vfr-routes-checkpoints/vfr-routes-checkpoints.js';

mount([g0, g1]);
